import { TemplateConfig, TypeTemplate } from "../../config";
import { Popover, Whisper } from "rsuite";

interface IProps {
  templateType: TypeTemplate;
  data: { [key: string]: any }[];
  errors: { [key: string]: any }[];
}

export function TemplatePreviewer({ templateType, data, errors }: IProps) {
  const template = (() => {
    switch (templateType) {
      case "Caregiver":
        return TemplateConfig.Column.caregiver;
      case "Patient":
        return TemplateConfig.Column.patient;
      default:
        return {};
    }
  })();
  const columns = Object.keys(template);
  const columnKeys = (() => {
    const data = [];
    for (const columnKey in template) {
      data.push(template[columnKey].key);
    }
    return data;
  })();
  const firstRow = (() => {
    const data = [];
    for (const columnKey in template) {
      data.push(template[columnKey].columnText);
    }
    return data;
  })();

  return (
    <div className="table-responsive template-data-preview">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th></th>
            {columns?.map((column) => (
              <th key={column}>{column}</th>
            ))}
          </tr>
          <tr>
            <th>1</th>
            {firstRow?.map((row) => (
              <th key={row}>{row}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((row, index) => (
            <tr key={index}>
              <td>{index + 2}</td>
              {Object.keys(columnKeys).map((_, rowIndex) => {
                const key = columnKeys[rowIndex];
                const errorMessage = errors[index]?.[key];
                return errorMessage?.length ? (
                  <Whisper
                    key={rowIndex}
                    placement="top"
                    speaker={
                      <Popover>{`[Row: ${index + 2}] ${errorMessage?.join(
                        " "
                      )}`}</Popover>
                    }
                  >
                    <td className="error">{row[key]}</td>
                  </Whisper>
                ) : (
                  <td key={rowIndex}>{row[key]}</td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
